<div class="container">
  <span class="eyebrow">{{ 'archives.eyebrow' | traduire }}</span>
  <h2>{{ 'archives.titre' | traduire }}</h2>

  <div class="arch-grid">
    <div class="arch-card" [class.tilt-a]="i % 2 === 0" [class.tilt-b]="i % 2 !== 0"
         *ngFor="let edition of editions; let i = index">
      <span class="pin"></span>
      <video *ngIf="estVideo(edition.photoUrl)" [src]="edition.photoUrl" muted loop autoplay playsinline></video>
      <img *ngIf="!estVideo(edition.photoUrl)" [src]="edition.photoUrl || 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=500'" [alt]="edition.theme">
      <div class="overlay">
        <div class="annee">{{ edition.annee }}</div>
        <p>{{ edition.theme }}</p>
        <p class="stats">{{ edition.nbSpectacles }} {{ 'archives.spectacles' | traduire }} · {{ edition.nbSpectateurs }} {{ 'archives.spectateurs' | traduire }}</p>
      </div>
    </div>
  </div>
</div>
